import Joi from '@hapi/joi';
import { User } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<User>>({
  firstName: Joi.string().allow('').max(255).messages({
    'string.max': 'STRING_MAX',
  }),
  lastName: Joi.string().allow('').max(255).messages({
    'string.max': 'STRING_MAX',
  }),
});

export default function (value: Partial<User>) {
  return validate(schema, value, {
    allowUnknown: false,
    context: {},
  });
}
